import "./App.css";
import * as ExcelJS from "exceljs";
import React from "react";
import "ag-grid-enterprise";
import { useEffect, useRef, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Button } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import { GridApi } from "ag-grid-community";
import merge from "lodash/merge";

import {
  CapitalizeFirstLetter,
  capitalizeAllLetter,
} from "../common-component/CapitalizeFirstLetter";
import Typography from "@mui/material/Typography";
import chartColors from "../../../components/extras/chartColors";
import { series } from "../../../common/data/chartDummyData";

export default function Charts(this: any, props: any) {
  const [tabWidgetInfo, setTabWidgetInfo] = useState<string>(
    props.widgetData?.info
  );
  const [dataRecieved, setDataRecieved] = useState(false);
  const [viewType, setViewType] = useState("default");
  const token = localStorage.getItem("token");
  const headers = new Headers({ Authorization: "Bearer " + token });
  const [state, setState] = useState<any>({ options: {}, series: [] });
  const [rows, setRows] = useState<any>(null);
  const [columns, setCoulmns] = useState<any>(null);
  const [queryId, setQueryId] = useState(0);
  const [print, setPrint] = useState(false);
  const [chartData, setChartData] = useState<any>(null);
  const [exportClick, setExportClick] = useState(false);
  const refreshClick = false;
  const [csvExportParam, setCsvExportParam] = useState({ fileName: "" });
  const gridApiRef = useRef<GridApi | null>(null); // Add type annotation for gridApi
  const gridColumnApiRef = useRef<null>(null); // Add type annotation for columnApi
  const vyu_api_url = process.env.REACT_APP_VYU_API_URL;
  const vyu_service_url = process.env.REACT_APP_VYU_SERVICE_URL;
  const [stateArea1, setStateArea1] = useState<any>({
    options: {},
    series: [],
  });
  const [stateArea, setStateArea] = useState<any>({ options: {}, series: [] });

  let keys: any = [];
  const componentRefPie = useRef(null);
  const componentRefBar = useRef(null);
  const componentRefLine = useRef(null);
  const componentRefArea = useRef(null);
  const componentRefScatter = useRef(null);
  const componentRefMultiLine = useRef(null);
  const componentRefMultiBar = useRef(null);
  const componentRefRangeBar = useRef(null);
  const componentRefTreemap = useRef(null);
  const componentRefColumnChart = useRef(null);
  const componentRefCandlestick = useRef(null);
  const componentRefRangeArea = useRef(null);
  const componentRefHeatMap = useRef(null);
  const componentRefBoxPlot = useRef(null);
  const componentRefRadar = useRef(null);
  const componentRefRadialBar = useRef(null);
  const componentRefDonut = useRef(null);
  const componentRefFunnel = useRef(null);
  const componentRefMultiAxis = useRef(null);
  const componentRefSynchronized = useRef(null);
  const componentRefDottedLine = useRef(null);

  const handlePrintPie = useReactToPrint({
    content: () => componentRefPie.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintBar = useReactToPrint({
    content: () => componentRefBar.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintLine = useReactToPrint({
    content: () => componentRefLine.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintArea = useReactToPrint({
    content: () => componentRefArea.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintScatter = useReactToPrint({
    content: () => componentRefScatter.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintMultiLine = useReactToPrint({
    content: () => componentRefMultiLine.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintMultiBar = useReactToPrint({
    content: () => componentRefMultiBar.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintRangeBar = useReactToPrint({
    content: () => componentRefRangeBar.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintTreeMap = useReactToPrint({
    content: () => componentRefTreemap.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintCandleStickMap = useReactToPrint({
    content: () => componentRefCandlestick.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintHeatMap = useReactToPrint({
    content: () => componentRefHeatMap.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintRangeArea = useReactToPrint({
    content: () => componentRefRangeArea.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintColumnChart = useReactToPrint({
    content: () => componentRefColumnChart.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintBoxPlotChart = useReactToPrint({
    content: () => componentRefBoxPlot.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintFunnel = useReactToPrint({
    content: () => componentRefFunnel.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintRadar = useReactToPrint({
    content: () => componentRefRadar.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintRadialBar = useReactToPrint({
    content: () => componentRefRadialBar.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintDonut = useReactToPrint({
    content: () => componentRefDonut.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintMultiAxis = useReactToPrint({
    content: () => componentRefMultiAxis.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintSynchronized = useReactToPrint({
    content: () => componentRefMultiAxis.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });
  const handlePrintDottedLineChart = useReactToPrint({
    content: () => componentRefDottedLine.current,
    onAfterPrint: () => props.parentCallbackPrint(false),
  });

  const onGridReady = (params: any) => {
    gridApiRef.current = params.api;
    gridColumnApiRef.current = params.columnApi;
  };

  const handleExportClick = async () => {
    // Get today's date and time in the desired format
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const date = String(now.getDate()).padStart(2, "0");
    let hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const amPm = hours >= 12 ? "PM" : "AM";

    // Convert 24-hour format to 12-hour format
    hours = hours % 12 || 12; // Convert '0' hours to '12'

    // Combine date and time
    const formattedDate = `${year}-${month}-${date}_${String(hours).padStart(2, "0")}-${minutes} ${amPm}`;

    // Accessing the grid API and exporting data as Excel
    if (gridApiRef.current) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      // Create a custom header with merged cells
      const widgetHeading =
        props.widgetData?.widget?.widget?.name ||
        props.widgetName ||
        "Widget Data";
      worksheet.mergeCells("A1:Z1"); // Merge cells for the first row (adjust the range as needed)
      worksheet.getCell("A1").value = widgetHeading.toUpperCase();
      worksheet.getCell("A1").alignment = {
        horizontal: "center",
        vertical: "middle",
      };
      worksheet.getCell("A1").font = { bold: true, size: 14 };
      // Set column widths
      const columnWidths = [20, 30, 15, 25]; // Customize widths as needed
      worksheet.columns = columnWidths.map((width) => ({ width }));
      // Add your grid data below the merged header row
      const rowData: any = gridApiRef?.current
        ?.getDataAsCsv()
        ?.split("\n")
        .map((row: any) => row.split(","))
        .filter((row: any) => row.length > 0) // Remove empty rows
        .map(
          (row: any) => row.map((cell: any) => cell.replace(/"/g, "").trim()) // Remove extra quotes and trim spaces
        );
      worksheet.columns = rowData[0]?.map(() => ({
        width: 40, // Adjust the width as needed for all columns
      }));
      // Add rows to the worksheet
      rowData.forEach((row: any, index: number) => {
        const worksheetRow = worksheet.addRow(row);

        // Apply bold style to cells in the second row (index 1 in rowData)
        if (index === 0) {
          worksheetRow.eachCell((cell: any) => {
            cell.font = { bold: true }; // Make each cell in the second row bold
            //   cell.alignment = { wrapText: true }; // Wrap text in the second row
          });
        }
      });

      // Save the Excel file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${widgetHeading}_${formattedDate}.xlsx`;
      link.click();
    }
  };

  useEffect(() => {
    if (props.viewType !== viewType) {
      setViewType(props.viewType);
    }

    if (props.refreshFlag && props.refreshFlag.refresh !== refreshClick) {
      if (props.widgetData.widget.widget.id === props.refreshFlag.widgetId)
        refreshCall();
      props.refreshCallback({
        refresh: false,
        widgetId: props.refreshFlag.widgetId,
      });
    }
    if (props.print) {
      if (props.print?.print !== print) {
        if (
          props.print.viewType === "Pie Chart" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintPie();
        } else if (
          props.print.viewType === "Bar Chart" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintBar();
        } else if (
          props.print.viewType === "Line Chart" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintLine();
        } else if (
          props.print.viewType === "Area Chart" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintArea();
        } else if (
          props.print.viewType === "Scatter Chart" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintScatter();
        } else if (
          props.print.viewType === "Multi Line Chart" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintMultiLine();
        } else if (
          props.print.viewType === "Multi Bar Chart" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintMultiBar();
        } else if (
          props.print.viewType === "Range Bar Chart" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintRangeBar();
        } else if (
          props.print.viewType === "Range Area Chart" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintRangeArea();
        } else if (
          props.print.viewType === "Tree Map Chart" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintTreeMap();
        } else if (
          props.print.viewType === "Candlestick Chart" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintCandleStickMap();
        } else if (
          props.print.viewType === "Heat Map Chart" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintHeatMap();
        } else if (
          props.print.viewType === "Column Chart" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintColumnChart();
        } else if (
          props.print.viewType === "Box Plot Chart" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintBoxPlotChart();
        } else if (
          props.print.viewType === "Funnel Chart" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintFunnel();
        } else if (
          props.print.viewType === "Radar" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintRadar();
        } else if (
          props.print.viewType === "RadialBar" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintRadialBar();
        } else if (
          props.print.viewType === "Donut" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintDonut();
        } else if (
          props.print.viewType === "Multi-Axis Chart" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintMultiAxis();
        } else if (
          props.print.viewType === "Dotted Line Chart" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintDottedLineChart();
        } else if (
          props.print.viewType === "Synchronized Chart" &&
          props.print.widgetId === props.widgetData.widget.widget.id
        ) {
          handlePrintSynchronized();
        }
      }
      if (props.export?.export) {
        if (props.export?.export !== exportClick) {
          handleExportClick();
          setExportClick(false);
          props.exportAfterCallback(false);
        }
      }
    }
    if (props.chartData) {
      chartTransform(props.chartData);
    }
    if (
      props.widgetData?.widget !== null &&
      props.widgetData?.widget !== undefined &&
      props.widgetData?.widget?.preview === false
    ) {
      const contextValue = "dashboard";
      setCsvExportParam({ fileName: props.widgetData?.widget.widget.name });
      // Direct API call without sessionStorage
      setTimeout(() => {
        fetch(
          `${vyu_service_url}/tabWidgetData?tabWidgetId=` +
            props.widgetData.i +
            `&context=${contextValue}`,
          { headers: headers }
        )
          .then((response) => response.json())
          .then((json: any) => {
            chartTransform(json);
          });
      });
      setTimeout(() => {
        fetch(`${vyu_api_url}/chart-data`, { headers: headers })
          .then((response) => response.json())
          .then((json) => {
            setChartData(json); // Update state with chart data
          })
          .catch((error) => console.error("Error fetching chart data:", error));
      });
    } else {
      if (
        props.widgetData?.queryObj !== null ||
        props.widgetData?.queryObj !== undefined
      ) {
        let contextValue: string;
        if (props.context) {
          contextValue = props.context;
        } else {
          contextValue = "widget";
        }

        setTimeout(() => {
          fetch(
            `${vyu_service_url}/getPreviewData?queryId=` +
              (typeof props.widgetData?.queryObj !== "number"
                ? props.widgetData?.queryObj?.id
                : props.widgetData?.queryObj) +
              `&context=${contextValue}`,
            { headers: headers }
          )
            .then((response) => response.json())
            .then((json) => {
              chartTransform(json);
            });
        });
        setTimeout(() => {
          fetch(`${vyu_api_url}/chart-data`, { headers: headers })
            .then((response) => response.json())
            .then((json) => {
              setChartData(json); // Update state with chart data
            })
            .catch((error) =>
              console.error("Error fetching chart data:", error)
            );
        });
      }
    }
  }, [
    props.viewType,
    props.timeout,
    props.refreshFlag,
    props.print,
    props.export,
    // props.isPreview,
  ]);

  const chartTransform = (json: any) => {
    if (json.obj) {
      for (let key of Object.keys(json.obj[0])) {
        keys.push(key);
      }
      if (props.viewType === "Grid") {
        let cols = [];
        let colObj: {
          field: string;
          headerName: string;
          filter: boolean;
          headerComponentParams?: any;
        } = {
          field: "",
          headerName: "",
          filter: false,
          headerComponentParams: {
            suppressMenu: true, // Hide the filter icon in the header
          },
        };

        for (const key of keys) {
          let colObj: {
            field: string;
            headerName: string;
            filter: boolean;
            headerComponentParams?: any;
          } = {
            field: "",
            headerName: "",
            filter: false,
            headerComponentParams: {
              suppressMenu: true, // Hide the filter icon in the header
            },
          };
          colObj["field"] = key;
          colObj["headerName"] = capitalizeAllLetter(key);
          colObj["filter"] = false;
          cols.push(colObj);
        }
        setCoulmns(cols);
        let count = 1;
        for (let obj of json.obj) {
          obj["id"] = count;
          count += 1;
        }
        setRows(json.obj);
        setDataRecieved(true);
      } else if (props.viewType === "Report") {
        let cols = [];
        let colObj: {
          field: string;
          headerName: string;
          filter: boolean;
          headerComponentParams?: any;
        } = {
          field: "",
          headerName: "",
          filter: false,
          headerComponentParams: {
            suppressMenu: true, // Hide the filter icon in the header
          },
        };

        for (const key of keys) {
          let colObj: {
            field: string;
            headerName: string;
            filter: boolean;
            headerComponentParams?: any;
          } = {
            field: "",
            headerName: "",
            filter: false,
            headerComponentParams: {
              suppressMenu: true, // Hide the filter icon in the header
            },
          };
          colObj["field"] = key;
          colObj["headerName"] = capitalizeAllLetter(key);
          colObj["filter"] = true;
          cols.push(colObj);
        }
        setCoulmns(cols);
        let count = 1;
        for (let obj of json.obj) {
          obj["id"] = count;
          count += 1;
        }
        setRows(json.obj);
        setDataRecieved(true);
      } else if (props.viewType === "Pie Chart") {
        let state = {
          options: {
            labels: json.obj.map((d: any) => capitalizeAllLetter(d[keys[0]])),
            title: {
              text: props.widgetData?.info || " ",
              align: "center",
              margin: 10,
              offsetX: 0,
              offsetY: 0,
              floating: false,
              style: {
                fontSize: "14px",
                fontWeight: "bold",
                fontFamily: "Poppins",
                color: "#263238",
              },
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 200,
                  },
                  stroke: {
                    width: 0,
                  },
                  legend: {
                    position: "bottom",
                  },
                },
              },
            ],
            //Adding 10 light colors for the slices
            colors: chartColors,
          },
          series: json.obj.map((d: any) => d[keys[1]]),
        };
        setState(state);
        console.log("IN PIE CXHART:", state.series);

        setDataRecieved(true);
      } else if (props.viewType === "Donut") {
        let state = {
          options: {
            chart: {
              type: "donut",
            },
            title: {
              text: props.widgetData?.info || props.widgetName,
              align: "center",
              margin: 10,
              style: {
                fontSize: "14px",
                fontWeight: "bold",
                fontFamily: "Poppins",
                color: "#263238",
              },
            },
            labels:
              json.obj.map((d: any) => capitalizeAllLetter(d[keys[0]])) || [],
            colors: chartColors,
          },
          series: json.obj.map((d: any) => d[keys[1]]),
        };
        setState(state);
        setDataRecieved(true);
      } else if (props.viewType === "Radar") {
        let series = [];
        for (let i = 1; i < keys.length; i++) {
          let obj: any = {};
          obj["name"] = capitalizeAllLetter(keys[i]);
          obj["data"] = json.obj.map((d: any) => d[keys[i]]);
          obj["labels"] = json.obj.map((d: any) => d[keys[0]]);
          series.push(obj);
        }

        let state = {
          options: {
            chart: {
              id: "radar-chart",
              type: "radar",
              height: "100%",
            },
            title: {
              text: props.widgetData?.info || props.widgetName,
              align: "center",
            },
            labels: series[0].labels,
          },
          series: series,
          // tooltip: {
          //   y: {
          //     formatter: (val: any) => `${val} %`,
          //   },
          // },
          // dataLabels: {
          //   formatter: (val: any) => `${val} %`,
          // },
          // yaxis: {
          //   labels: {
          //     formatter: (val: any) => `${val} %`,
          //   },
          // },
        };
        setState(state);
        setDataRecieved(true);
      } else if (props.viewType === "Multi-Axis Chart") {
        let series = [];
        let x_axisTitle;
        for (let i = 1; i < keys.length; i++) {
          const keys = Object.keys(json.obj[0]);
          x_axisTitle = capitalizeAllLetter(keys[0]);
          let obj: any = {};
          obj["name"] = capitalizeAllLetter(keys[i]);
          obj["data"] = json.obj.map((d: any) => d[keys[i]]);
          obj["labels"] = json.obj.map((d: any) => d[keys[0]]);
          series.push(obj);
        }
        console.log("series for Multi-Axis Chart:", series);

        let state = {
          options: {
            chart: {
              height: 350,
              type: "line",
              stacked: false,
            },
            dataLabels: {
              enabled: true,
            },
            colors: ["#FF1654", "#247BA0"],
            title: {
              text: props.widgetData?.info || props.widgetName,
              align: "center",
              margin: 10,
              style: {
                fontSize: "14px",
                fontWeight: "bold",
                fontFamily: "Poppins",
                color: "#263238",
              },
            },
            stroke: {
              width: [4, 4],
            },
            plotOptions: {
              bar: {
                columnWidth: "20%",
              },
            },
            legend: {
              position: "bottom",
              horizontalAlign: "center",
              floating: false,
            },
            xaxis: {
              categories: series[0].labels,
              tickAmount: 6, // Limit the number of labels shown
              labels: {
                rotate: 0,
                trim: true,
              },
              title: {
                text: x_axisTitle,
              },
            },

            yaxis: [
              {
                axisTicks: {
                  show: true,
                },
                axisBorder: {
                  show: true,
                  color: "#FF1654",
                },
                labels: {
                  style: {
                    colors: "#FF1654",
                  },
                },
                title: {
                  text: series[0].name || "",
                  style: {
                    color: "#FF1654",
                  },
                },
              },
              {
                opposite: true,
                axisTicks: {
                  show: true,
                },
                axisBorder: {
                  show: true,
                  color: "#247BA0",
                },
                labels: {
                  style: {
                    colors: "#247BA0",
                  },
                },
                title: {
                  text: series[1]?.name || "",
                  style: {
                    color: "#247BA0",
                  },
                },
              },
            ],

            tooltip: {
              enabled: true,
              // shared: false,
              // intersect: true,
            },
          },
          series: series,
        };
        setState(state);
        setDataRecieved(true);
      } else if (props.viewType === "Synchronized Chart") {
        let series = [];
        for (let i = 0; i < keys.length; i++) {
          let obj: any = {};
          obj["name"] = capitalizeAllLetter(keys[i]);
          obj["data"] = json.obj.map((d: any) => d[keys[i]]);
          // obj["labels"] = json.obj.map((d: any) => d.x);
          series.push(obj);
        }
        let yColumn1 = keys[1]; // Y column name for chart 1
        let yColumn2 = keys[2];
        let chart1Data = [];
        let y_axisLabel1 = "";
        let chart2Data = [];
        let y_axisLabel2 = "";

        for (let i = 0; i < series[0]?.data.length; i++) {
          chart1Data.push({
            x: series[0]?.data[i] || "",
            y: series[1]?.data[i] || "",
          });

          chart2Data.push({
            x: series[0]?.data[i] || "",
            y: series[2]?.data[i] || "",
          });
        }

        let state1 = {
          series: [
            {
              name: yColumn1 || "",
              data: chart1Data,
            },
          ],
          options: {
            chart: {
              id: "line-chart",
              type: "line",
            },
            dataLabels: {
              enabled: true,
            },
            xaxis: {
              title: {
                text: series[0].name || "", // Set Y-axis title
              },
              type: "category",
              labels: {
                format: "yyyy-MM-dd",
              },
            },
            yaxis: {
              title: {
                text: series[1].name || "", // Set Y-axis title
                style: {
                  fontSize: "12px",
                  fontWeight: "bold",
                  color: "#333",
                },
              },
            },
            title: {
              text: props.widgetData?.info || props.widgetName,
              align: "center",
              style: {
                fontSize: "16px",
                fontWeight: "bold",
                fontFamily: "Poppins",
                color: "#333",
              },
            },
            tooltip: {
              y: {
                formatter: (val: any) => `${val} Units`, // Add units to tooltip values
              },
            },
            colors: ["#FF6347"],
          },
        };
        setStateArea1(state1);

        let state2 = {
          series: [
            {
              name: yColumn2 || "",
              data: chart2Data,
            },
          ],
          options: {
            chart: {
              id: "bar-chart",
              type: "line",
            },
            dataLabels: {
              enabled: true,
            },
            xaxis: {
              title: {
                text: series[0]?.name || "", // Set Y-axis title
              },
              type: "category",
              labels: {
                format: "yyyy-MM-dd",
              },
            },
            yaxis: {
              title: {
                text: series[2]?.name || "", // Set Y-axis title
                style: {
                  fontSize: "12px",
                  fontWeight: "bold",
                  color: "#333",
                },
              },
            },
            // title: {
            //   text: props.widgetData?.info || props.widgetName,
            //   align: "center",
            //   style: {
            //     fontSize: "16px",
            //     fontWeight: "bold",
            //     fontFamily: "Poppins",
            //     color: "#333",
            //   },
            // },
            tooltip: {
              y: {
                formatter: (val: any) => `${val} Units`, // Add units to tooltip values
              },
            },
          },
        };

        setStateArea(state2);
        setDataRecieved(true);
      }
      // else if (props.viewType === "RadialBar") {
      //   if (!chartData || !Array.isArray(chartData.radialBarChartData)) {
      //     console.error(
      //       "Invalid or undefined chartData.radialBarChartData",
      //       chartData
      //     );
      //     return;
      //   }
      //   console.log(
      //     "chartData.radialBarChartData:",
      //     chartData.radialBarChartData
      //   );

      //   let state = {
      //     options: {
      //       chart: {
      //         type: "radialBar",
      //         title: {
      //           text: props.widgetData.info,
      //           align: "center",
      //           margin: 10,
      //           offsetX: 0,
      //           offsetY: 0,
      //           floating: false,
      //           style: {
      //             fontSize: "14px",
      //             fontWeight: "bold",
      //             fontFamily: "Poppins",
      //             color: "#263238",
      //           },
      //         },
      //       },
      //       series: [chartData.radialBarChartData[0].value],
      //       labels: [chartData.radialBarChartData[0].label],
      //     },
      //   };
      //   setState(state);
      //   setDataRecieved(true);
      // }
      else if (props.viewType === "Funnel Chart") {
        const keys = Object.keys(json.obj[0]);
        const x = json.obj.map((data: any) => data[keys[0]]);
        const y = json.obj.map((item: any) => item[keys[1]]);
        const xKey = keys[0];
        const yKey = keys[1];
        let state = {
          options: {
            chart: {
              id: "funnel-chart",
              type: "bar",
              height: "100%",
            },
            plotOptions: {
              bar: {
                horizontal: true,
                isFunnel: true,
                barHeight: "80%",
              },
            },
            title: {
              text: props.widgetData?.info || props.widgetName,
              align: "center",
            },
            xaxis: {
              categories: x,
            },
          },
          series: [
            {
              name: yKey || "", // Series name
              data: y, // Data for the chart
            },
          ],
        };
        setState(state);
        setDataRecieved(true);
      } else if (props.viewType === "Range Area Chart") {
        const keys = Object.keys(json.obj[0]);
        const x_axisTitle = capitalizeAllLetter(keys[0]);
        const y_keys = Object.keys(json.obj[1]);
        const y_axisTitle1 = capitalizeAllLetter(y_keys[1]);
        const y_keys2 = Object.keys(json.obj[1]);
        const y_axisTitle2 = capitalizeAllLetter(y_keys2[1]);
        const y_axisTitle = `${y_axisTitle1} & ${y_axisTitle2}`;

        const getData = json.obj
          .map((item: any) => {
            const keys = Object.keys(item);
            const [firstColumn] = keys.slice(0, 1);
            const [secondColumn, thirdColumn] = keys.slice(1, 3);

            if (
              secondColumn &&
              thirdColumn &&
              item[secondColumn] !== undefined &&
              item[thirdColumn] !== undefined
            ) {
              return {
                x: item[firstColumn],
                y: [item[secondColumn], item[thirdColumn]],
              };
            } else {
              console.warn(`Insufficient data for ${item.name}, skipping item`);
              return null;
            }
          })
          .filter((item: any) => item !== null); // Remove null entries

        // Chart state configuration
        let state = {
          options: {
            chart: {
              height: 350,
              type: "rangeArea",
            },
            dataLabels: {
              enabled: false,
            },
            markers: {
              hover: {
                sizeOffset: 5,
              },
            },
            title: {
              text:
                props.widgetData?.info ||
                props.widgetData?.name ||
                "Default Info",
              align: "center",
              margin: 10,
              style: {
                fontSize: "14px",
                fontWeight: "bold",
                fontFamily: "Poppins",
                color: "#263238",
              },
            },
            xaxis: {
              type: "category", // Ensures labels are treated as categories
              title: {
                text: x_axisTitle,
                style: {
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "Poppins",
                  color: "#263238",
                },
              },
              tooltip: {
                enabled: true,
                formatter: (value: string, opts: any) => {
                  const index = opts.dataPointIndex; // Index of the hovered category
                  return json.obj[index][keys[0]]; // Return the full label from the data
                },
              },
            },
            yaxis: {
              title: {
                text: y_axisTitle,
                style: {
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "Poppins",
                  color: "#263238",
                },
              },
              tooltip: {
                enabled: true,
                formatter: (value: string, opts: any) => {
                  const index = opts.dataPointIndex; // Index of the hovered category
                  return json.obj[index][keys[0]]; // Return the full label from the data
                },
              },
            },
            stroke: {
              curve: "straight",
            },
          },
          series: [
            {
              name: "Range Area Data", // The name for this series
              data: getData, // The data points for the chart
            },
          ],
        };

        setState(state); // Set the chart state
        setDataRecieved(true); // Mark data as received
      } else if (props.viewType === "Range Bar Chart") {
        // Map the data from the backend response to chart-compatible format
        const getData = json.obj
          .map((item: any) => {
            const keys = Object.keys(item);
            const [firstColumn] = keys.slice(0, 1);
            const [secondColumn, thirdColumn] = keys.slice(1, 3);

            if (
              secondColumn &&
              thirdColumn &&
              item[secondColumn] !== undefined &&
              item[thirdColumn] !== undefined
            ) {
              return {
                x: item[firstColumn],
                y: [item[secondColumn], item[thirdColumn]],
              };
            } else {
              console.warn(`Insufficient data for ${item.name}, skipping item`);
              return null;
            }
          })
          .filter((item: any) => item !== null); // Remove null entries

        let state = {
          options: {
            chart: {
              type: "rangeBar",
            },
            title: {
              text:
                props.widgetData?.info ||
                props.widgetData?.name ||
                "Default Info",
              align: "center",
              margin: 10,
              style: {
                fontSize: "14px",
                fontWeight: "bold",
                fontFamily: "Poppins",
                color: "#263238",
              },
            },
          },
          series: [
            {
              data: getData,
            },
          ],
        };
        setState(state);
        setDataRecieved(true);
      } else if (props.viewType === "Tree Map Chart") {
        let state = {
          options: {
            chart: {
              type: "treemap",
              toolbar: { show: false },
            },
            title: {
              text:
                props.widgetData?.info ||
                props.widgetData?.name ||
                "Default Info",
              align: "center",
              margin: 10,
              style: {
                fontSize: "14px",
                fontWeight: "bold",
                fontFamily: "Poppins",
                color: "#263238",
              },
            },
          },
          series: [
            {
              data: json.obj.map((d: any) => ({
                x: d[keys[0]], // First key as category
                y: d[keys[1]], // Second key as value
              })),
            },
          ],
        };
        setState(state);
        setDataRecieved(true);
      } else if (props.viewType === "Heat Map Chart") {
        const sample = json?.obj?.[0];

        const allKeys = Object.keys(sample || {});

        // Find first non-numeric key (assuming string = label)
        const dynamicLabelKey = allKeys.find(
          (key) => typeof sample[key] === "string"
        );

        // Ensure the key is defined before using it
        if (dynamicLabelKey) {
          const dynamicCategories = allKeys.filter(
            (key) => key !== dynamicLabelKey && typeof sample[key] === "number"
          );

          const seriesData = json?.obj?.map((row: any) => ({
            name: row[dynamicLabelKey],
            data: dynamicCategories.map((key) => row[key]),
          }));

          let state = {
            options: {
              chart: {
                type: "heatmap",
                height: 250,
              },
              plotOptions: {
                heatmap: {
                  colorScale: {
                    ranges: [
                      { from: 0, to: 50, name: "Low", color: "#00A100" },
                      { from: 50, to: 100, name: "Medium", color: "#FFB200" },
                      { from: 200, to: 300, name: "High", color: "#FF0000" },
                    ],
                  },
                },
              },
              title: {
                text:
                  props.widgetData?.info ||
                  props.widgetData?.name ||
                  props.widgetName ||
                  "Default Info",
                align: "center",
                margin: 10,
                style: {
                  fontSize: "14px",
                  fontWeight: "bold",
                  fontFamily: "Poppins",
                  color: "#263238",
                },
              },
              xaxis: {
                type: "category",
                categories: dynamicCategories,
                title: {
                  text: props.xAxisLabel || "Quarter",
                },
              },
              yaxis: {
                title: {
                  text: props.yAxisLabel || dynamicLabelKey,
                },
              },
            },
            series: seriesData,
          };

          setState(state);
          setDataRecieved(true);
        } else {
          console.error(
            "Could not determine the label column in Heat Map data."
          );
        }
      } else if (props.viewType === "Column Chart") {
        const firstItemKeys =
          json.obj && json.obj.length > 0 ? Object.keys(json.obj[0]) : [];
        const xAxisKey = firstItemKeys[0] || "x";
        const columnName = firstItemKeys[1] || "value"; // 👈 Dynamic Y-axis column

        const categories = json.obj.map((item: any) => item[xAxisKey]);

        const series = [
          {
            name: columnName,
            data: json.obj.map((item: any) => ({
              x: item[xAxisKey],
              y: item[columnName],
              goals: [
                {
                  name: "Expected",
                  value: item[columnName] + 1,
                  strokeHeight: 5,
                  strokeColor: "#775DD0",
                },
              ],
            })),
          },
        ];

        const state = {
          options: {
            chart: { height: 350, type: "bar" },
            plotOptions: { bar: { columnWidth: "60%" } },
            colors: ["#00E396"],
            dataLabels: { enabled: false },
            legend: {
              show: true,
              showForSingleSeries: true,
              customLegendItems: ["Actual", "Expected"],
              markers: {
                fillColors: ["#00E396", "#775DD0"],
              },
            },
            title: {
              text:
                props.widgetData?.info ||
                props.widgetData?.name ||
                "Column Chart",
              align: "center",
            },
            xaxis: {
              categories: categories,
              title: {
                text: xAxisKey, // Optional: Dynamic X-axis label
              },
            },
            yaxis: {
              title: {
                text: columnName, // ✅ Dynamic Y-axis label
              },
            },
          },
          series: series,
        };

        setState(state);
        setDataRecieved(true);
      } else if (props.viewType === "Candlestick Chart") {
        const transformData = () => {
          if (!json?.obj?.length) return [];

          const keys = Object.keys(json.obj[0]);
          const timeKey = keys[0]; // First column - used for timestamp

          return json.obj.map((item: any) => {
            const timestamp = new Date(`${item[timeKey]}-01`).getTime(); // Use dynamic key
            return [timestamp, item.open, item.high, item.low, item.close];
          });
        };

        // Get first and last column names dynamically
        const keys =
          json?.obj && json.obj.length > 0 ? Object.keys(json.obj[0]) : [];
        const xAxisTitle = keys[0] || "Date"; // first column
        const yAxisTitle = keys[keys.length - 1] || "Value"; // Last column

        let state = {
          options: {
            chart: {
              type: "candlestick",
              height: 250,
            },
            title: {
              text:
                props.widgetData?.info ||
                props.widgetData?.name ||
                "Candlestick Chart",
              align: "center",
            },
            xaxis: {
              type: "datetime",
              title: {
                text: xAxisTitle,
              },
            },
            yaxis: {
              title: {
                text: yAxisTitle,
              },
            },
          },
          series: [
            {
              name: "Stock Price",
              data: transformData(),
            },
          ],
        };

        setState(state);
        setDataRecieved(true);
      } else if (props.viewType === "Box Plot Chart") {
        const firstItem = json?.obj?.[0];
        const columnKeys = firstItem ? Object.keys(firstItem) : [];

        const xAxisKey = columnKeys[0] || "category"; // e.g., category, date
        const yAxisKeys = columnKeys.slice(1, 6); // assuming [open, high, average, low, close]

        const transformData = () => {
          return json?.obj.map((item: any) => {
            console.log("In Box Plot Chart x axis key", item[xAxisKey]);
            console.log("In Box Plot Chart y axis key", [
              item.open,
              item.high,
              item.average,
              item.low,
              item.close,
            ]);
            return {
              x: item[xAxisKey],
              y: [item.open, item.high, item.average, item.low, item.close],
            };
          });
        };

        let state = {
          options: {
            chart: {
              type: "boxPlot",
              height: 250,
            },
            title: {
              text:
                props.widgetData?.info ||
                props.widgetData?.name ||
                "Box Plot Chart",
              align: "center",
            },
            xaxis: {
              type: "category",
              title: {
                text: xAxisKey, // ✅ Dynamic X-axis title
              },
            },
            yaxis: {
              title: {
                text: yAxisKeys.join(", "), // ✅ Dynamic Y-axis title
              },
            },
          },
          series: [
            {
              name: "Data Range",
              data: transformData(),
            },
          ],
        };

        setState(state);
        setDataRecieved(true);
      } else {
        let series = [];
        if (
          props.viewType === "Multi Line Chart" ||
          props.viewType === "Multi Bar Chart"
        ) {
          for (let i = 1; i < keys.length; i++) {
            let obj: any = {};
            obj["name"] = capitalizeAllLetter(keys[i]);
            obj["data"] = json.obj.map((d: any) => d[keys[i]]);
            series.push(obj);
          }
        }
        let state: any = {
          options: {
            // title: {
            //   text: capitalizeAllLetter(
            //     props.widgetData.info || props.widgetName
            //   ),
            //   align: "center",
            //   margin: 10,
            //   offsetX: 0,
            //   offsetY: 0,
            //   floating: false,
            //   style: {
            //     fontSize: "14px",
            //     fontWeight: "bold",
            //     fontFamily: "Poppins",
            //     color: "#263238",
            //   },
            // },
            chart: {
              toolbar: {
                show: false,
              },
            },
            labels: {
              show: true,
              align: "right",
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: "smooth",
            },
            xaxis: {
              type: "category",
              categories: json.obj.map((d: any) =>
                capitalizeAllLetter(d[keys[0]])
              ),
              tickAmount: undefined,
              tickPlacement: "between",
              min: undefined,
              max: undefined,
              stepSize: undefined,
              range: undefined,
              floating: false,
              decimalsInFloat: undefined,
              overwriteCategories: undefined,
              position: "bottom",
              tooltip: {
                enabled: true,
                formatter: (value: string, opts: any) => {
                  const index = opts.dataPointIndex; // Index of the hovered category
                  return json.obj[index][keys[0]]; // Return the full label from the data
                },
              },
              labels: {
                show: true,
                rotate: 0,
                rotateAlways: false,
                hideOverlappingLabels: true,
                showDuplicates: false,
                trim: false,
                minHeight: undefined,
                maxHeight: 120,
                style: {
                  colors: [],
                  fontSize: "12px",
                  fontFamily: "Helvetica, Arial, sans-serif",
                  fontWeight: 400,
                  cssClass: "apexcharts-xaxis-label",
                },
              },
              title: {
                text: capitalizeAllLetter(keys[0]),
                style: {
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "Poppins",
                  color: "#263238",
                },
              },
            },
            yaxis: {
              categories: json.obj.map((d: any) => d[keys[1]]),
              title: {
                text: capitalizeAllLetter(keys[1]),
              },
            },
          },
          series:
            props.viewType === "Multi Line Chart" ||
            props.viewType === "Multi Bar Chart"
              ? series
              : [
                  {
                    name: keys[1],
                    data: json.obj.map((d: any) => d[keys[1]]),
                  },
                ],
        };
        setState(state);
        setDataRecieved(true);
      }
    }
  };

  const refreshCall = () => {
    const contextValue = "dashboard";
    fetch(
      `${vyu_service_url}/tabWidgetData?tabWidgetId=` +
        props.widgetData.i +
        `&context=${contextValue}`,
      { headers: headers }
    )
      .then((response) => response.json())
      .then((json: any) => {
        if (json.obj === null || json.obj === undefined) {
          console.log("This iniside if condition......", json.obj);

          // Case: obj is null or undefined
          props.queryParamRefreshCallBack(true);
        } else if (Array.isArray(json.obj) && json.obj.length === 0) {
          console.log("This iniside 1st else if condition......", json.obj);
          // Case: obj is an empty array
          props.queryParamRefreshCallBack(true);
        } else if (typeof json.obj === "string" && json.obj.length === 0) {
          console.log("This iniside 2nd else if condition......", json.obj);
          // Case: obj is an empty string
          props.queryParamRefreshCallBack(true);
        } else {
          // Case: obj is valid
          chartTransform(json);
          props.queryParamRefreshCallBack(false);
        }

        // chartTransform(json);
      });
  };

  const truncatedLabelsOptions = {
    title: {
      text:
        props.widgetData?.info ||
        props.widgetData?.name ||
        props.widgetName ||
        "Default Info",
      align: "center",
      margin: 10,
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        fontFamily: "Poppins",
        color: "#263238",
      },
    },
    xaxis: {
      categories: state.options?.xaxis?.categories || [], // Ensure categories are provided
      labels: {
        formatter: function (value: any) {
          // Ensure value is a string and truncate if it's longer than 4 characters
          return typeof value === "string"
            ? value.length > 4
              ? value.substring(0, 4) + "..."
              : value
            : String(value);
        },
        style: {
          fontSize: "12px",
        },
      },
    },
    // yaxis: {
    //   title: {
    //     text: "Count",
    //   },
    // },
    tooltip: {
      enabled: true,
      x: {
        show: true,
        formatter: function (value: any) {
          // Return the full value in the tooltip
          return String(value);
        },
      },
    },
  };

  const mergedOptions = merge({}, state.options, truncatedLabelsOptions);
  const updatedState = {
    ...state,
    options: {
      ...state.options,
      title: {
        text: capitalizeAllLetter(props.widgetData?.info || props?.widgetName),
        align: "center",
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
          fontSize: "14px",
          fontWeight: "bold",
          fontFamily: "Poppins",
          color: "#263238",
        },
      },
    },
  };
  const updatedStateArea1 = {
    ...stateArea1,
    options: {
      ...stateArea1.options,
      title: {
        text: capitalizeAllLetter(props.widgetData?.info || props?.widgetName),
        align: "center",
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
          fontSize: "14px",
          fontWeight: "bold",
          fontFamily: "Poppins",
          color: "#263238",
        },
      },
    },
  };
  if (!dataRecieved) {
    return (
      <Box
        sx={{
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "20%",
        }}
      >
        <CircularProgress />
      </Box>
    );
  } else {
    // const isSeriesNumeric =
    //   Array.isArray(updatedState.series) &&
    //   updatedState.series.every(
    //     (value: any) => typeof value === "number" && !isNaN(value)
    //   );
    const parseNumericValue = (value: any): number | null => {
      if (typeof value === "number") return value;
      if (typeof value !== "string") return null;

      const match = value
        .trim()
        .toLowerCase()
        .match(/^(\d+(\.\d+)?)[\s]*([km])?$/);
      if (!match) return null;

      let num = parseFloat(match[1]);
      const suffix = match[3];

      if (suffix === "k") num *= 1_000;
      if (suffix === "m") num *= 1_000_000;

      return num;
    };

    const isSeriesNumeric = updatedState.series.every((value: any) => {
      const parsed = parseNumericValue(value);
      return typeof parsed === "number" && !isNaN(parsed);
    });

    const isMultiLineSeriesNumeric =
      Array.isArray(updatedState.series) &&
      updatedState.series.every(
        (serie: any) =>
          Array.isArray(serie.data) &&
          serie.data.every((value: any) => {
            const parsed = parseNumericValue(value);
            return typeof parsed === "number" && !isNaN(parsed);
          })
      );

    switch (viewType) {
      case "Pie Chart":
        return (
          <>
            {isSeriesNumeric || isMultiLineSeriesNumeric ? (
              <>
                <ReactToPrint content={() => componentRefPie.current} />
                <ReactApexChart
                  ref={componentRefPie}
                  options={updatedState.options}
                  series={updatedState.series}
                  title={"Pie Chart"}
                  type="pie"
                  width={"100%"}
                  height={"80%"}
                  style={{ marginTop: 3 }}
                />
              </>
            ) : (
              <div>
                Data does not support the Pie Chart type. Numeric values are
                required.
              </div>
            )}
          </>
        );

      case "Donut":
        return (
          <>
            {isSeriesNumeric || isMultiLineSeriesNumeric ? (
              <>
                <ReactToPrint content={() => componentRefDonut.current} />
                <Box
                  ref={componentRefDonut}
                  sx={{ width: "100%", height: "100%" }}
                >
                  <ReactApexChart
                    // options={{
                    //   chart: {
                    //     type: "donut",
                    //   },
                    //   title: {
                    //     text: props.widgetData?.info || props.widgetName,
                    //     align: "center",
                    //     margin: 10,
                    //     style: {
                    //       fontSize: "14px",
                    //       fontWeight: "bold",
                    //       fontFamily: "Poppins",
                    //       color: "#263238",
                    //     },
                    //   },
                    //   labels: chartData.donutChartData[0]?.label || [],
                    //   colors: chartColors,
                    // }}
                    // series={chartData.donutChartData[0]?.value || []}
                    options={updatedState.options}
                    series={updatedState.series}
                    type="donut"
                    width={"100%"}
                    height={"80%"}
                  />
                </Box>
              </>
            ) : (
              <div>
                Data does not support the Donut Chart type. Numeric values are
                required.
              </div>
            )}
          </>
        );

      case "Line Chart":
        return (
          <>
            {isMultiLineSeriesNumeric || isSeriesNumeric ? (
              <>
                <ReactToPrint content={() => componentRefLine.current} />
                <ReactApexChart
                  ref={componentRefLine}
                  options={updatedState.options}
                  series={updatedState.series}
                  title={"Line Chart"}
                  type="line"
                  width={"90%"}
                  height={"80%"}
                />
              </>
            ) : (
              <div>
                Data does not support the Line Chart type. Numeric values are
                required.
              </div>
            )}
          </>
        );

      case "Bar Chart":
        console.log("updatedState.series Bar Chart:", updatedState.series);

        return (
          <>
            {isMultiLineSeriesNumeric || isSeriesNumeric ? (
              <>
                <ReactToPrint content={() => componentRefBar.current} />
                <ReactApexChart
                  ref={componentRefBar}
                  options={updatedState.options}
                  series={updatedState.series}
                  type="bar"
                  width={"90%"}
                  height={"80%"}
                />
              </>
            ) : (
              <div>
                Data does not support the Bar Chart type. Numeric values are
                required.
              </div>
            )}
          </>
        );

      case "Area Chart":
        return (
          <>
            {isMultiLineSeriesNumeric || isSeriesNumeric ? (
              <>
                <ReactToPrint content={() => componentRefArea.current} />
                <ReactApexChart
                  ref={componentRefArea}
                  options={updatedState.options}
                  series={updatedState.series}
                  type="area"
                  width={"90%"}
                  height={"80%"}
                />
              </>
            ) : (
              <div>
                Data does not support the Area Chart type. Numeric values are
                required.
              </div>
            )}
          </>
        );

      case "Scatter Chart":
        return (
          <>
            {isMultiLineSeriesNumeric || isSeriesNumeric ? (
              <>
                <ReactToPrint content={() => componentRefScatter.current} />
                <ReactApexChart
                  ref={componentRefScatter}
                  options={updatedState.options}
                  series={updatedState.series}
                  type="scatter"
                  width={"90%"}
                  height={"80%"}
                />
              </>
            ) : (
              <div>
                Data does not support the Scatter Chart type. Numeric values are
                required.
              </div>
            )}
          </>
        );

      case "Multi Line Chart":
        return (
          <>
            {isMultiLineSeriesNumeric || isSeriesNumeric ? (
              <>
                <ReactToPrint content={() => componentRefMultiLine.current} />
                <ReactApexChart
                  ref={componentRefMultiLine}
                  options={updatedState.options}
                  series={updatedState.series}
                  type="line"
                  width={"90%"}
                  height={"80%"}
                />
              </>
            ) : (
              <div>
                Data does not support the Multi Line Chart type. All series
                values must be numeric.
              </div>
            )}
          </>
        );

      case "Multi Bar Chart":
        console.log(
          "updatedState.series in Multibar chart:",
          updatedState.series
        );

        return (
          <>
            {isMultiLineSeriesNumeric || isSeriesNumeric ? (
              <>
                <ReactToPrint content={() => componentRefMultiBar.current} />
                <ReactApexChart
                  ref={componentRefMultiBar}
                  options={mergedOptions}
                  series={updatedState.series}
                  type="bar"
                  width={"90%"}
                  height={"80%"}
                />
              </>
            ) : (
              <div>
                Data does not support the Multi Bar Chart type. Numeric values
                are required.
              </div>
            )}
          </>
        );

      case "Column Chart":
        return (
          <>
            <ReactToPrint content={() => componentRefColumnChart.current} />
            <ReactApexChart
              ref={componentRefColumnChart}
              options={updatedState.options}
              series={updatedState.series}
              type="bar"
              width={"90%"}
              height={"80%"}
            />
          </>
        );

      case "Candlestick Chart":
        console.log("In Candlestick Chart case:", updatedState.series);

        return (
          <>
            <ReactToPrint content={() => componentRefCandlestick.current} />
            <ReactApexChart
              ref={componentRefCandlestick}
              options={updatedState.options}
              series={updatedState.series}
              type="candlestick"
              width={"90%"}
              height={"80%"}
            />
          </>
        );

      case "Box Plot Chart":
        return (
          <>
            <ReactToPrint content={() => componentRefBoxPlot.current} />
            <ReactApexChart
              ref={componentRefBoxPlot}
              options={updatedState.options}
              series={updatedState.series}
              type="boxPlot"
              width={"90%"}
              height={"80%"}
            />
          </>
        );

      case "Range Area Chart":
        return (
          <>
            <ReactToPrint content={() => componentRefRangeArea.current} />
            <ReactApexChart
              ref={componentRefRangeArea}
              options={mergedOptions}
              series={state.series}
              type="rangeArea"
              width={"90%"}
              height={"80%"}
            />
          </>
        );

      case "Range Bar Chart":
        return (
          <>
            <ReactToPrint content={() => componentRefRangeBar.current} />
            <ReactApexChart
              ref={componentRefRangeBar}
              options={mergedOptions}
              series={state.series}
              type="rangeBar"
              width={"90%"}
              height={"80%"}
            />
          </>
        );

      case "Radar":
        return (
          <>
            {isMultiLineSeriesNumeric || isSeriesNumeric ? (
              <>
                <ReactToPrint content={() => componentRefRadar.current} />
                <Box
                  ref={componentRefRadar}
                  sx={{ width: "100%", height: "100%" }}
                >
                  <ReactApexChart
                    //   options={
                    //     {
                    //     chart: {
                    //       id: "radar-chart",
                    //       type: "radar",
                    //       height: "100%",
                    //     },
                    //     title: {
                    //       text: props.widgetData?.info || props.widgetName,
                    //       align: "center",
                    //     },
                    //     labels: [
                    //       "April",
                    //       "May",
                    //       "June",
                    //       "July",
                    //       "August",
                    //       "September",
                    //     ],
                    //   }
                    // }
                    //   series={chartData?.radarChartData || []}
                    options={updatedState.options}
                    series={updatedState.series}
                    type="radar"
                    width={"100%"}
                    height={"80%"}
                  />
                </Box>
              </>
            ) : (
              <div>
                Data does not support the Radar Chart type. Numeric values are
                required.
              </div>
            )}
          </>
        );

      case "Tree Map Chart":
        return (
          <>
            <ReactToPrint content={() => componentRefTreemap.current} />
            <Box sx={{ width: "90%", height: "100%", marginLeft: "6%" }}>
              <ReactApexChart
                ref={componentRefTreemap}
                options={mergedOptions}
                series={state.series}
                type="treemap"
                width={"100%"}
                height={"80%"}
              />
            </Box>
          </>
        );

      case "Heat Map Chart":
        return (
          <>
            <ReactToPrint content={() => componentRefHeatMap.current} />
            <ReactApexChart
              ref={componentRefHeatMap}
              options={mergedOptions}
              series={state.series}
              type="heatmap"
              width={"90%"}
              height={"80%"}
            />
          </>
        );

      case "RadialBar":
        return (
          <>
            {isMultiLineSeriesNumeric || isSeriesNumeric ? (
              <>
                <ReactToPrint content={() => componentRefRadialBar.current} />
                <Box
                  ref={componentRefRadialBar}
                  sx={{ width: "90%", height: "80%" }}
                >
                  <ReactApexChart
                    options={{
                      chart: {
                        id: "radial-bar-chart",
                        type: "radialBar",
                        height: "100%",
                      },
                      title: {
                        text: props.widgetData?.info || props.widgetName,
                        align: "center",
                      },
                    }}
                    series={[chartData?.radialBarChartData[0]?.value || 0]}
                    type="radialBar"
                    width={"100%"}
                    height={300}
                  />
                </Box>
              </>
            ) : (
              <div>
                Data does not support the RadialBar Chart type. Numeric values
                are required.
              </div>
            )}
          </>
        );

      case "Funnel Chart":
        return (
          <>
            {isMultiLineSeriesNumeric || isSeriesNumeric ? (
              <>
                <ReactToPrint content={() => componentRefFunnel.current} />
                <Box sx={{ width: "90%", height: "100%", marginLeft: "6%" }}>
                  <ReactApexChart
                    options={updatedState.options}
                    series={updatedState.series}
                    type="bar"
                    width={"90%"}
                    height={"90%"}
                  />
                </Box>
              </>
            ) : (
              <div>
                Data does not support the Funnel Chart type. Numeric values are
                required.
              </div>
            )}
          </>
        );

      case "Multi-Axis Chart":
        return (
          <>
            <ReactToPrint content={() => componentRefMultiAxis.current} />
            <Box
              ref={componentRefMultiAxis}
              sx={{ width: "100%", height: "100%" }}
            >
              <ReactApexChart
                // options={{
                //   chart: {
                //     height: 350,
                //     type: "line",
                //     stacked: false,
                //   },
                //   dataLabels: {
                //     enabled: false,
                //   },
                //   colors: ["#FF1654", "#247BA0"],
                //   title: {
                //     text: props.widgetData?.info || props.widgetName,
                //     align: "center",
                //     margin: 10,
                //     style: {
                //       fontSize: "14px",
                //       fontWeight: "bold",
                //       fontFamily: "Poppins",
                //       color: "#263238",
                //     },
                //   },
                //   stroke: {
                //     width: [4, 4],
                //   },
                //   plotOptions: {
                //     bar: {
                //       columnWidth: "20%",
                //     },
                //   },
                //   xaxis: {
                //     categories: [
                //       2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016,
                //     ],
                //   },
                //   yaxis: [
                //     {
                //       axisTicks: {
                //         show: true,
                //       },
                //       axisBorder: {
                //         show: true,
                //         color: "#FF1654",
                //       },
                //       labels: {
                //         style: {
                //           colors: "#FF1654",
                //         },
                //       },
                //       title: {
                //         text: "Series A",
                //         style: {
                //           color: "#FF1654",
                //         },
                //       },
                //     },
                //     {
                //       opposite: true,
                //       axisTicks: {
                //         show: true,
                //       },
                //       axisBorder: {
                //         show: true,
                //         color: "#247BA0",
                //       },
                //       labels: {
                //         style: {
                //           colors: "#247BA0",
                //         },
                //       },
                //       title: {
                //         text: "Series B",
                //         style: {
                //           color: "#247BA0",
                //         },
                //       },
                //     },
                //   ],
                //   tooltip: {
                //     shared: false,
                //     intersect: true,
                //   },
                //   legend: {
                //     horizontalAlign: "left",
                //     offsetX: 40,
                //   },
                // }}
                // series={chartData.multiAxisData}
                options={updatedState.options}
                series={updatedState.series}
                type="line"
                width={"100%"}
                height={"90%"}
              />
            </Box>
          </>
        );

      case "Synchronized Chart":
        // console.log(
        //   "stateArea1.series in Synchronized Chart:",
        //   stateArea1.series
        // );
        // console.log(
        //   "stateArea.series in Synchronized Chart:",
        //   stateArea.series
        // );
        // const isSeriesYValuesNumeric = (series: any[]): boolean => {
        //   if (!Array.isArray(series)) return false;
        //   return series.every(
        //     (s) =>
        //       Array.isArray(s.data) &&
        //       s.data.every(
        //         (point: any) =>
        //           (typeof point.x === "string" ||
        //             typeof point.x === "number") &&
        //           typeof point.y === "number" &&
        //           !isNaN(point.y)
        //       )
        //   );
        // };

        // const isSynchronizedSeriesNumeric =
        //   isSeriesYValuesNumeric(stateArea1.series) &&
        //   isSeriesYValuesNumeric(stateArea.series);

        return (
          <>
            {/* {isSynchronizedSeriesNumeric ? (
              <> */}
            <ReactToPrint content={() => componentRefSynchronized.current} />
            <Box
              ref={componentRefMultiAxis}
              sx={{ width: "100%", height: "100%" }}
            >
              <div id="chart-line" style={{ height: "50%", width: "100%" }}>
                <ReactApexChart
                  options={updatedStateArea1.options}
                  series={stateArea1.series}
                  type="line"
                  width={"100%"}
                  height={"100%"}
                />
              </div>
              <div id="chart-bar" style={{ height: "45%", width: "100%" }}>
                <ReactApexChart
                  options={stateArea.options}
                  series={stateArea.series}
                  type="line"
                  width={"100%"}
                  height={"100%"}
                />
              </div>
            </Box>
          </>
          //   ) : (
          //     <div>
          //       Data does not support the Synchronized Chart type. Numeric
          //       values are required.
          //     </div>
          //   )}
          // </>
        );

      case "Grid":
        console.log("Printing View Type:", viewType);

        return (
          <Box width={"90%"} height={"80%"} marginTop={5} sx={{ margin: 4 }}>
            <Typography
              // variant="h5"
              align="center"
              sx={{
                marginBottom: 2,
                marginTop: -5,
                fontWeight: "bold",
                fontFamily: "Poppins",
                color: "#263238",
              }}
            >
              {props?.widgetData?.info || props?.widgetName || "Data Grid"}
            </Typography>
            <AgGridReact
              className="ag-theme-quartz cancelSelectorName"
              rowData={rows}
              columnDefs={columns}
              // pagination={true}
              suppressExcelExport={true}
              defaultCsvExportParams={csvExportParam}
              onGridReady={onGridReady}
            />
          </Box>
        );
      case "Report":
        console.log("Printing View Type in REport:", viewType);
        return (
          <Box width={"100%"} height={"100%"}>
            <AgGridReact
              className="ag-theme-quartz cancelSelectorName"
              rowData={rows}
              columnDefs={columns}
              // pagination={true}
              suppressExcelExport={true}
              defaultCsvExportParams={csvExportParam}
              onGridReady={onGridReady}
            />
          </Box>
        );
      default:
        return null;
    }
  }
}
